import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import BlogEditor from "./BlogEditor";

export default function BlogAdminList({
  baseURL = "https://gantasoft.in/rankridgecollege/dev/v1",
  apiKey = "12345678",
}) {
  const api = useMemo(()=>axios.create({ baseURL, headers: { "X-API-Key": apiKey } }), [baseURL, apiKey]);
  const [rows,setRows]=useState([]), [q,setQ]=useState(""), [status,setStatus]=useState(""), [page,setPage]=useState(1);
  const [pages,setPages]=useState(0), [total,setTotal]=useState(0), [loading,setLoading]=useState(true);
  const [editor,setEditor]=useState(null);

  async function load(){
    setLoading(true);
    try{
      const params = { include_tags:1, sort:"updated_date", order:"DESC", page, limit:20 };
      if (q.trim()) params.q=q;
      if (status) params.status=status;
      const {data} = await api.get("/posts",{ params });
      setRows(data?.items||[]); setPages(data?.pagination?.pages||0); setTotal(data?.pagination?.total||0);
    } finally { setLoading(false); }
  }
  useEffect(()=>{ load(); /* eslint-disable-next-line */ },[q,status,page]);

  const del = async it => { if(!window.confirm("Delete this post?")) return;
    await api.delete(`/posts/${it.post_id}`); setRows(r=>r.filter(x=>x.post_id!==it.post_id));
  };

  const toggle = async it => {
    const next = it.status === "published" ? "archived" : "published";
    await api.patch(`/posts/${it.post_id}`, { field:"status", value: next });
    setRows(r => r.map(x => x.post_id===it.post_id ? { ...x, status: next } : x));
  };

  return (
    <div className="max-w-7xl mx-auto p-4">
      <div className="flex justify-between items-end gap-2">
        <h2 className="text-xl font-semibold">Blog Posts</h2>
        <div className="flex gap-2">
          <input className="border rounded px-3 py-2" placeholder="Search…" value={q} onChange={e=>{setPage(1);setQ(e.target.value);}} />
          <select className="border rounded px-3 py-2" value={status} onChange={e=>{setPage(1);setStatus(e.target.value);}}>
            <option value="">All</option><option value="draft">draft</option><option value="scheduled">scheduled</option>
            <option value="published">published</option><option value="archived">archived</option>
          </select>
          <button className="px-3 py-2 bg-green-700 text-white rounded" onClick={()=>setEditor({})}>+ New</button>
        </div>
      </div>

      {loading ? <div className="mt-4 text-gray-500">Loading…</div> : (
        rows.length===0 ? <div className="mt-4 text-gray-500">No posts.</div> :
        <div className="mt-4 grid gap-3">
          {rows.map(it=>(
            <div key={it.post_id} className="border rounded p-3 bg-white">
              <div className="flex justify-between items-center">
                <div>
                  <div className="font-semibold">{it.title}</div>
                  <div className="text-xs text-gray-500">{it.slug}</div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xs px-2 py-0.5 bg-gray-100 rounded">{it.status}</span>
                  <span className="text-xs px-2 py-0.5 bg-gray-100 rounded">{it.reading_time_min||1} min</span>
                </div>
              </div>
              {it.excerpt && <div className="text-sm text-gray-600 mt-1 line-clamp-2">{it.excerpt}</div>}
              <div className="text-xs text-gray-500 mt-2 flex gap-2 flex-wrap">
                {it.category_name && <span className="bg-gray-100 px-2 py-0.5 rounded">{it.category_name}</span>}
                {(it.tags||[]).map(t=><span key={t.tag_id} className="bg-gray-100 px-2 py-0.5 rounded">#{t.name}</span>)}
              </div>
              <div className="flex gap-2 mt-2">
                <button className="text-xs px-2 py-1 rounded bg-blue-600 text-white" onClick={()=>setEditor(it)}>Edit</button>
                <button className="text-xs px-2 py-1 rounded bg-gray-800 text-white" onClick={()=>toggle(it)}>
                  {it.status==='published'?'Archive':'Publish'}
                </button>
                <button className="text-xs px-2 py-1 rounded bg-red-600 text-white" onClick={()=>del(it)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {pages>1 && (
        <div className="mt-4 flex items-center gap-2">
          <button className="px-3 py-1.5 rounded bg-gray-200 disabled:opacity-50" disabled={page<=1} onClick={()=>setPage(p=>Math.max(1,p-1))}>Prev</button>
          <div className="text-sm">Page {page} of {pages} • {total} total</div>
          <button className="px-3 py-1.5 rounded bg-gray-200 disabled:opacity-50" disabled={page>=pages} onClick={()=>setPage(p=>p+1)}>Next</button>
        </div>
      )}

      {editor && (
        <BlogEditor
          baseURL={baseURL}
          apiKey={apiKey}
          initial={editor}
          onClose={()=>setEditor(null)}
          onSaved={()=>{ setEditor(null); load(); }}
        />
      )}
    </div>
  );
}
